import { Component, OnInit, ViewEncapsulation , ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
import { CurrentUserService } from 'src/app/services/current-user.service';

@Component({
    selector: 'app-payment-cancel',
    templateUrl: './payment-cancel.component.html',
    styleUrls: ['./payment-cancel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PaymentCancelComponent implements OnInit {
  cancelDetails: any = {};
  loading: boolean = true;
  userId: number | string;
  userEmail: string;
  userFullName: string;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToastService,
    private currentUserService: CurrentUserService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.setUpCurrentUser();
    this.getCancelDetails();
  }

  setUpCurrentUser() {
    this.currentUserService.currentUser.subscribe((res) => {
      if (res) {
        this.userId = res.id;
        this.userEmail = res.email;
        this.userFullName = res.first_name + " " + res.last_name;
        this.cdr.detectChanges();
      }
    });
  }

  getCancelDetails() {
    // Get cancel details from URL parameters
    this.route.queryParams.subscribe(params => {
      if (params['session_id']) {
        this.cancelDetails.sessionId = params['session_id'];
      }
      if (params['plan_name']) {
        this.cancelDetails.planName = params['plan_name'];
      }
      if (params['amount']) {
        this.cancelDetails.amount = params['amount'];
      }
      if (params['reason']) {
        this.cancelDetails.reason = params['reason'];
      }
      
      this.loading = false;
      this.cdr.detectChanges();
      this.showCancelMessage();
    });
  }

  showCancelMessage() {
    this.toasterService.showSuccess('Payment was cancelled. No charges were made to your account.','warning');
  }

  retryPayment() {
    // Navigate back to payment page with the same plan details
    const queryParams: any = {};
    if (this.cancelDetails.planName) {
      queryParams.plan = this.cancelDetails.planName;
    }
    if (this.cancelDetails.amount) {
      queryParams.amount = this.cancelDetails.amount;
    }
    
    this.router.navigate(['/subscription'], { queryParams: { isUser: true } });
  }

  goToSubscription() {
    this.router.navigate(['/subscription'], { queryParams: { isUser: true } });
  }

  goToDashboard() {
    this.router.navigate(['/home']);
  }

  contactSupport() {
    // You can implement this to open a support modal or navigate to contact page
    this.toasterService.showNote('Please contact our support team for assistance.');
  }


} 